"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.survTempZone = exports.survNIHSSScore = exports.survMALINASScore = exports.survApgarScore = exports.survTemp = exports.survHemoglobineFloat = exports.survScoreSed = exports.survGlycemie = exports.survGlaMotricite = exports.survGlaVerbal = exports.survGlaYeux = exports.survScoreGla = exports.survGlaFlat = exports.survPupilles = exports.survShockIndex = exports.survPaleurs = exports.survTrc = exports.survHbco = exports.survHemocue = exports.survHemoglobine = exports.survTensionManuelleSystoliqueDroite = exports.survTensionManuelleSystoliqueGauche = exports.survTensionManuelleSystolique = exports.survTensionMoyenne = exports.survPamByUser = exports.survPamg = exports.survPabg = exports.survPamd = exports.survPabd = exports.survFc = exports.survPeakFlow = exports.survChocIndex = exports.survChocNbr = exports.survChocTime = exports.survChocDate = exports.survRespirateurPep = exports.survRespirateurVt = exports.survRespirateurFio2 = exports.survRespirateurFr = exports.survEtco = exports.survSpco = exports.survDispositifOxygenotherapie = exports.survDebitO2 = exports.survO2o2 = exports.survO2aa = exports.survFr = exports.survAvpu = exports.survInconscience = exports.survTime = exports.survDate = void 0;
exports.survScore = exports.survE = exports.survD = exports.survC = exports.survAb = exports.survHead = exports.survApgar = exports.survObstetrique = exports.survComment = exports.survDouleur = void 0;
const data_1 = require("../data");
const utils = __importStar(require("../utils"));
const utils_1 = require("../utils");
exports.survDate = [
    {
        '@type': 'surveillance',
        key: '1e6de5ef-06f8-4274-a4ce-2bb449224294',
        label: 'Date',
        value: surv => {
            return !surv.date ? ''
                : surv.date.setZone('Europe/Paris').setLocale('fr-fr')
                    .toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' });
        },
        webDisplay: 'common',
    },
];
exports.survTime = [
    {
        '@type': 'surveillance',
        key: '363f13bb-8135-479f-a9a6-c5a489dac37c',
        label: 'Heure',
        value: surv => {
            return typeof surv.heure === 'string'
                ? `${surv.heure.padStart(2, '0')}:${surv.minute.padStart(2, '0')}`
                : `${surv.heure}:${surv.minute}`;
        },
        webDisplay: 'common',
    },
];
exports.survInconscience = [
    {
        '@type': 'surveillance',
        key: 'eb846146-f07f-4e62-9412-a59e7684930d',
        label: 'Inconscience',
        value: surv => {
            if (surv.inconscience === 'y')
                return 'Oui';
            if (surv.inconscience === 'n')
                return 'Non';
            return null;
        },
        webDisplay: 'surveillance',
    },
];
exports.survAvpu = [
    {
        '@type': 'surveillance',
        key: 'c4cafde8-808e-427b-a6ae-59651bfe0b83',
        label: 'AVPU',
        value: surv => data_1.AVPU_OPTS.find(opt => opt.value === surv.avpu)?.label ?? null,
        webDisplay: 'surveillance',
    },
];
exports.survFr = [
    {
        '@type': 'surveillance',
        key: '44937f45-0ad3-4ad9-afaa-08dd8d1bebcf',
        label: 'FR',
        unit: cUser => utils.hasPerm(cUser, 'assessment:b:secondaire:fr:unit_cycles')
            ? 'cycles'
            : utils.hasPerm(cUser, 'assessment:constant:fr:unit_mvt_min')
                ? 'mvt/min'
                : 'cpm',
        value: surv => surv.fr,
        valueUnit: '',
        webDisplay: 'surveillance',
    },
];
exports.survO2aa = [
    {
        '@type': 'surveillance',
        key: 'e6915bb5-8df3-48f7-ae1d-72f1a073e044',
        label: 'SpO² ambiant',
        unit: '%',
        value: surv => surv.o2aa || surv.spo2,
        valueUnit: '',
        webDisplay: 'surveillance',
    },
];
exports.survO2o2 = [
    {
        '@type': 'surveillance',
        key: '1dd28d4e-2e87-476b-a9a7-4e308e1f77ec',
        label: 'SpO² sous O²',
        unit: '%',
        value: surv => surv.spo2_with_o2 || surv.o2o2,
        valueUnit: '',
        webDisplay: 'surveillance',
    },
];
exports.survDebitO2 = [
    {
        '@type': 'surveillance',
        key: '2e9f394f-f424-4168-938a-2c1c941b8bb4',
        label: 'Débit O²',
        value: surv => {
            return (surv.debit_o2 && surv.debit_o2 !== -1) ? surv.debit_o2 : surv.oxy_debit;
        },
        valueUnit: surv => surv.oxy_debit_unit === 0 ? 'L/min' : surv.oxy_debit_unit === 1 ? '%' : '',
        webDisplay: 'surveillance',
    },
];
exports.survDispositifOxygenotherapie = [
    {
        '@type': 'surveillance',
        key: '186f164d-f354-4fcf-84d7-7d823ab49e9f',
        label: "Dispositif d'oxygénothérapie",
        value: surv => {
            let value = null;
            switch (surv.dispositif_oxygeno) {
                case 1:
                    value = "Aucun";
                    break;
                case 2:
                    value = "Masque HC";
                    break;
                case 3:
                    value = "Lunettes O2";
                    break;
                case 4:
                    value = "Masque Moyenne concentration";
                    break;
                case 5:
                    value = "Intubation";
                    break;
                case 6:
                    value = "BAVU";
                    break;
            }
            return value;
        },
        webDisplay: 'surveillance',
    },
];
exports.survSpco = [
    {
        '@type': 'surveillance',
        key: 'cf926bc4-4e00-4b32-9303-112e40cdb8a0',
        label: bilan => {
            return `SpCo${bilan.respiration.spco_precision === 0
                ? ' transcutané'
                : bilan.respiration.spco_precision === 1
                    ? ' expiré'
                    : ''}`;
        },
        unit: bilan => utils.hasPerm(bilan, 'assessment:constant:spco:ppm:unit:visible') || bilan.respiration?.spco_unite === 1
            ? 'ppm'
            : '%',
        value: surv => surv.spco_decimal || surv.spco,
        valueUnit: '',
        webDisplay: 'surveillance',
    },
];
exports.survEtco = [
    {
        '@type': 'surveillance',
        key: '476b457a-fd57-4302-9e17-e303e6b2cb18',
        label: 'EtCO²',
        unit: 'mmHg',
        value: surv => surv.etco2,
        webDisplay: 'surveillance',
    },
];
exports.survRespirateurFr = [
    {
        '@type': 'surveillance',
        key: 'e23291aa-191c-4fe4-a434-a955a520bd31',
        label: 'Respi - FR',
        unit: '/min',
        value: surv => surv.respirateur_fr,
        webDisplay: 'surveillance',
    },
];
exports.survRespirateurFio2 = [
    {
        '@type': 'surveillance',
        key: 'dec5d57f-615d-4bda-967d-024e2a61b9b3',
        label: 'Respi - FiO²',
        unit: '%',
        value: surv => surv.respirateur_fio2,
        webDisplay: 'surveillance',
    },
];
exports.survRespirateurVt = [
    {
        '@type': 'surveillance',
        key: '824fa384-f53c-42d0-9e44-f08dbbbce269',
        label: 'Respi - VT',
        unit: 'mL',
        value: surv => surv.respirateur_vt,
        webDisplay: 'surveillance',
    },
];
exports.survRespirateurPep = [
    {
        '@type': 'surveillance',
        key: '8556d98c-e61d-4211-bcad-f7a7d4a25896',
        label: 'Respi - PEP',
        unit: 'cmH2O',
        value: surv => surv.respirateur_pep,
        webDisplay: 'surveillance',
    },
];
exports.survChocDate = [
    {
        '@type': 'surveillance',
        key: 'e23291aa-191c-4fe4-a434-a955a520bd31',
        label: 'Choc - Date',
        unit: '',
        value: surv => surv.choc_date,
        webDisplay: 'surveillance',
    },
];
exports.survChocTime = [
    {
        '@type': 'surveillance',
        key: '5fd17ea7-eb0b-43d6-8bfc-b23024229c2f',
        label: 'Choc - Heure',
        unit: '',
        value: surv => surv.choc_time,
        webDisplay: 'surveillance',
    },
];
exports.survChocNbr = [
    {
        '@type': 'surveillance',
        key: '44b49338-0aef-49e2-b4d6-a4779a7f1dd4',
        label: 'Choc - Nbr total',
        unit: '',
        value: surv => surv.nb_choc_total,
        webDisplay: 'surveillance',
    },
];
exports.survChocIndex = [
    {
        '@type': 'surveillance',
        key: 'be78b04b-9e7f-45ef-8df0-a111944da2ad',
        label: 'Choc Index',
        unit: '',
        value: surv => surv.choc_index,
        webDisplay: 'surveillance',
    },
];
exports.survPeakFlow = [
    {
        '@type': 'surveillance',
        key: '9c84bcb2-e22a-42ce-88cf-230262deaaf7',
        label: 'Peak Flow',
        unit: 'L/min',
        value: surv => surv.peak_flow,
        webDisplay: 'surveillance',
    },
];
exports.survFc = [
    {
        '@type': 'surveillance',
        key: '75b73961-5523-47f3-9c64-0c05fd6168fa',
        label: 'FC',
        unit: bilan => (utils.hasPerm(bilan, 'assessment:bilan:fc:unit:cpm') ? 'cpm' : 'bpm'),
        value: surv => surv.fc,
        valueUnit: surv => surv.fc_type === 0 ? 'R' : surv.fc_type === 1 ? 'I' : '',
        webDisplay: 'surveillance',
    },
];
exports.survPabd = [
    {
        '@type': 'surveillance',
        key: 'c718ef0d-7cae-4967-91be-3d8c6e7545c9',
        label: 'PABD',
        value: surv => surv.pabd,
        valueUnit: surv => (surv.pamd !== null ? `(${surv.pamd})` : ''),
        webDisplay: 'surveillance',
    },
];
exports.survPamd = [
    {
        '@type': 'surveillance',
        key: '1de269bd-e206-4dbf-97ea-f63842d51d40',
        label: 'PAMD',
        value: surv => surv.pambd || surv.pamd,
        webDisplay: 'surveillance',
    },
];
exports.survPabg = [
    {
        '@type': 'surveillance',
        key: 'd80ea51a-b05b-4719-a95c-4a4d5b205e04',
        label: 'PABG',
        value: surv => surv.pabg,
        valueUnit: surv => (surv.pamg !== null ? `(${surv.pamg})` : ''),
        webDisplay: 'surveillance',
    },
];
exports.survPamg = [
    {
        '@type': 'surveillance',
        key: 'c33a4ef1-5d35-41b7-b238-9e18096c1284',
        label: 'PAMG',
        value: surv => surv.pambg || surv.pamg,
        webDisplay: 'surveillance',
    },
];
exports.survPamByUser = [
    {
        '@type': 'surveillance',
        key: 'a88c7a71-cc8e-410a-a59a-4d0cc9e10ffe',
        label: "PAM par l'utilisateur",
        value: surv => {
            if (surv.is_pam_entry_by_user === 'y' || surv.is_pam_entry_by_user === true)
                return 'Oui';
            if (surv.is_pam_entry_by_user === 'n' || surv.is_pam_entry_by_user === false)
                return 'Non';
            return null;
        },
        webDisplay: 'surveillance',
    },
];
exports.survTensionMoyenne = [
    {
        '@type': 'surveillance',
        key: 'f6dd8c5a-388f-46ab-b9a3-a8993e434683',
        label: 'Tension moyenne',
        value: surv => surv.tension_moyenne,
        webDisplay: 'surveillance',
    },
];
exports.survTensionManuelleSystolique = [
    {
        '@type': 'surveillance',
        key: '6bd718f8-4710-48cf-9b06-9f4daba91f27',
        label: 'TA manuelle - Systolique',
        unit: 'cmH20',
        value: surv => surv?.tension_manuelle_systolique,
        webDisplay: 'surveillance',
    },
];
exports.survTensionManuelleSystoliqueGauche = [
    {
        '@type': 'surveillance',
        key: '34a2b607-778a-4eeb-9c7d-7157a39057e8',
        label: 'TA manuelle - Systolique gauche',
        unit: 'cmH20',
        value: surv => surv?.tension_manuelle_systolique_gauche,
        webDisplay: 'surveillance',
    },
];
exports.survTensionManuelleSystoliqueDroite = [
    {
        '@type': 'surveillance',
        key: '6a5a9226-f13a-477a-85c2-c4dd5ec79457',
        label: 'TA manuelle - Systolique droite',
        unit: 'cmH20',
        value: surv => surv?.tension_manuelle_systolique_droite,
        webDisplay: 'surveillance',
    },
];
exports.survHemoglobine = [
    {
        '@type': 'surveillance',
        key: '1e48ff26-b426-4fc6-903c-ac6bc905a463',
        label: 'Hémoglobine',
        unit: 'g/dL',
        value: surv => surv.hemoglobine,
        webDisplay: 'surveillance',
    },
];
exports.survHemocue = [
    {
        '@type': 'surveillance',
        key: '252488df-546c-4129-b4d5-808a60405a7c',
        label: 'Hémocue',
        unit: 'g/L',
        value: surv => surv.hemocue,
        webDisplay: 'surveillance',
    },
];
exports.survHbco = [
    {
        '@type': 'surveillance',
        key: 'fd9f378b-0d78-4730-854f-627fe7034c04',
        label: 'hbco',
        unit: '%',
        value: surv => surv.hbco,
        webDisplay: 'surveillance',
    },
];
exports.survTrc = [
    {
        '@type': 'surveillance',
        key: '77ce813f-80d3-47f2-b51d-a7afecc9e02f',
        label: 'TRC > 3 sec',
        value: surv => (surv.trc === 'y' ? 'Oui' : surv.trc === 'n' ? 'Non' : null),
        webDisplay: 'surveillance',
    },
];
exports.survPaleurs = [
    {
        '@type': 'surveillance',
        key: '53b475b5-0d38-49b5-b54a-1686b9829b70',
        label: 'Pâleurs',
        value: surv => data_1.PALEURS_OPTS.find(opt => opt.value === surv.paleur)?.label ?? null,
        webDisplay: 'surveillance',
    },
];
exports.survShockIndex = [
    {
        '@type': 'surveillance',
        key: '8c23ecb4-cbd8-4507-b10c-c9534e5b9dd8',
        label: 'Shock',
        value: surv => surv.shockIndex,
        webDisplay: 'surveillance',
    },
];
exports.survPupilles = [
    {
        '@type': 'surveillance',
        key: '926e91b0-5af6-47d6-b49b-ac586462eb37',
        label: 'Pupillles',
        value: surv => {
            if (surv.pupilles_bilateral) {
                return utils.multiselect2text(surv.pupilles_bilateral, data_1.PUPILLES_BILATERAL_OPTS)?.join(', ');
            }
            return utils.multiselect2text(surv.pupilles, data_1.PUPILLES_OPTS)?.join(', ') ?? null;
        },
        webDisplay: 'surveillance',
    },
];
exports.survGlaFlat = [
    {
        '@type': 'surveillance',
        key: '059259c3-1ae2-4fe5-9ab8-05324396a02c',
        label: 'Glasgow',
        value: surv => {
            const hasGlasgow = surv.glasgow_yeux || surv.glasgow_verbal || surv.glasgow_motricite;
            const score = surv.glasgow
                ? surv.glasgow
                : hasGlasgow
                    ? utils.glasgowScoreValue(surv.glasgow_yeux, surv.glasgow_verbal, surv.glasgow_motricite)
                    : utils.glasgowScoreValue(surv.gla_yeux, surv.gla_parole, surv.gla_motricite);
            const y = hasGlasgow
                ? data_1.GLASGOW_Y_OPTS.find(opt => opt.value === surv.glasgow_yeux)?.value ?? null
                : data_1.GLA_Y_OPTS.find(opt => opt.value === surv.gla_yeux)?.value ?? null;
            const p = data_1.GLA_V_OPTS.find(opt => opt.value === surv.gla_parole || opt.value === surv.glasgow_verbal)?.value ?? null;
            const m = hasGlasgow
                ? data_1.GLASGOW_M_OPTS.find(opt => opt.value === surv.glasgow_motricite)?.value ?? null
                : data_1.GLA_M_OPTS.find(opt => opt.value === surv.gla_motricite)?.value ?? null;
            if ((!y && !p && !m) || (!y && !p && !m && !surv.glasgow))
                return null;
            return `${score ?? '--'} (Y=${y ?? '--'} V=${p ?? '--'} M=${m ?? '--'})`;
        },
        webDisplay: 'surveillance',
    },
];
exports.survScoreGla = [
    {
        '@type': 'surveillance',
        key: '0b49327a-7e26-467a-b9ef-9434a0b63f38',
        label: 'Score de Glasgow',
        value: surv => surv.glasgow
            ? surv.glasgow
            : surv.glasgow_yeux || surv.glasgow_verbal || surv.glasgow_motricite
                ? utils.glasgowScoreValue(surv.glasgow_yeux, surv.glasgow_verbal, surv.glasgow_motricite)
                : utils.glasgowScoreValue(surv.gla_yeux, surv.gla_parole, surv.gla_motricite),
        webDisplay: 'surveillance',
    },
];
exports.survGlaYeux = [
    {
        '@type': 'surveillance',
        key: '11d5e61d-563a-40cd-97f7-025ad40538ab',
        label: 'Glasgow Yeux',
        value: surv => {
            if (surv.glasgow_yeux) {
                return data_1.GLASGOW_Y_OPTS.find(opt => opt.value === surv.glasgow_yeux)?.label ?? null;
            }
            return data_1.GLA_Y_OPTS.find(opt => opt.value === surv.gla_yeux)?.label ?? null;
        },
        webDisplay: 'surveillance',
    },
];
exports.survGlaVerbal = [
    {
        '@type': 'surveillance',
        key: 'fb627343-d187-43c7-a96b-6fed47572022',
        label: 'Glasgow Verbal',
        value: surv => data_1.GLA_V_OPTS.find(opt => opt.value === surv.gla_parole || opt.value === surv.glasgow_verbal)?.label ?? null,
        webDisplay: 'surveillance',
    },
];
exports.survGlaMotricite = [
    {
        '@type': 'surveillance',
        key: '51745e97-c99c-4709-b929-179862ba3880',
        label: 'Glasgow Motricité',
        value: surv => {
            if (surv.glasgow_motricite) {
                return data_1.GLASGOW_M_OPTS.find(opt => opt.value === surv.glasgow_motricite)?.label ?? null;
            }
            return data_1.GLA_M_OPTS.find(opt => opt.value === surv.gla_motricite)?.label ?? null;
        },
        webDisplay: 'surveillance',
    },
];
exports.survGlycemie = [
    {
        '@type': 'surveillance',
        key: 'd57af865-1c45-455b-b503-5be166380465',
        label: 'Glycémie',
        value: surv => {
            switch (surv.glycemie) {
                case -2:
                case '-2.0':
                case '-2':
                    return 'LO';
                case -3:
                case '-3.0':
                case '-3':
                    return 'HI';
                default:
                    return surv.glycemie;
            }
        },
        valueUnit: surv => data_1.GLYCEMIE_UNITS.get(surv.glycemie_unite),
        webDisplay: 'surveillance',
    },
];
exports.survScoreSed = [
    {
        '@type': 'surveillance',
        key: '4cb29f4e-9444-4c20-8e0f-5dbd56700cd6',
        label: 'État de conscience',
        value: surv => data_1.SCORE_SEDATION_OPTS.find(opt => opt.value === surv.score_sedation)?.label ?? null,
        webDisplay: 'surveillance',
    },
];
exports.survHemoglobineFloat = [
    {
        '@type': 'surveillance',
        key: '5c814935-2178-4fbb-b84d-af158a841841',
        label: 'Hémoglobine',
        unit: 'g/dl',
        value: surv => surv.hemoglobine_float,
        webDisplay: 'surveillance',
    },
];
exports.survTemp = [
    {
        '@type': 'surveillance',
        key: '59d273ee-4df2-4f53-9269-fc899afd1abf',
        label: 'Temp.',
        unit: '°C',
        value: surv => surv.temperature,
        webDisplay: 'surveillance',
    },
];
exports.survApgarScore = [
    {
        '@type': 'surveillance',
        key: '646551b9-5c72-4d70-bd10-12e4c6bf4d05',
        label: 'APGAR',
        value: surv => surv.apgar_score,
        webDisplay: 'surveillance',
    },
];
exports.survMALINASScore = [
    {
        '@type': 'surveillance',
        key: 'ab7d04a8-d667-4042-adf2-d0df861c5549',
        label: 'MALINAS',
        value: surv => surv.malinas,
        webDisplay: 'surveillance',
    },
];
exports.survNIHSSScore = [
    {
        '@type': 'surveillance',
        key: '935bdb92-d799-413d-9f60-551844da6b26',
        label: 'NIHSS',
        value: surv => surv.nihss,
        webDisplay: 'surveillance',
    },
];
exports.survTempZone = [
    {
        '@type': 'surveillance',
        key: '7c910965-c396-422d-9b5c-2b82f9a5b33a',
        label: 'Temp zone',
        unit: '',
        value: surv => data_1.TEMPERATURE_ZONE_OPTS.find(opt => opt.value === surv.temperature_zone)?.label ?? null,
        webDisplay: 'surveillance',
    },
];
exports.survDouleur = [
    {
        '@type': 'surveillance',
        key: 'c6c6bb60-301f-42bb-b79b-f0496f66311a',
        label: cUser => `Douleur${utils.hasPerm(cUser, 'assessment:abcde:e:secondaire:douleur-en:visible') ? ' EN' : ''}`,
        value: surv => surv.eva,
        valueUnit: '/10',
        webDisplay: 'surveillance',
    },
];
exports.survComment = [
    {
        '@type': 'surveillance',
        key: '9346b61b-a518-483d-a26b-d55822a591ef',
        label: 'Commentaire',
        value: surv => surv.comment,
        webDisplay: 'common',
    },
];
exports.survObstetrique = [
    {
        '@type': 'surveillance',
        key: '8adcfe3a-d63c-43dd-a854-b2d587f65f0c',
        label: 'Score Malinas',
        value: surv => {
            const parite = surv?.obst?.malinas_parite;
            const travail = surv?.obst?.malinas_travail;
            const duree = surv?.obst?.malinas_duree_contraction;
            const inter = surv?.obst?.malinas_intervalle_contraction;
            const perte = surv?.obst?.malinas_perte_eaux;
            if (parite === null || travail === null || duree === null || inter === null || perte === null) {
                return null;
            }
            return parite + travail + duree + inter + perte - 5;
        },
        webDisplay: 'surveillance',
    },
    {
        '@type': 'surveillance',
        key: 'de817334-fe5c-4346-8f55-0acdeb3ed477',
        label: 'Parité',
        value: surv => surv?.obst?.nombre_pars,
        webDisplay: 'surveillance',
    },
    {
        '@type': 'surveillance',
        key: '6230ea4d-1247-4185-9e80-5295daefe236',
        label: 'Durée travail',
        value: surv => data_1.MALINAS_TRAVAIL_OPTS.find(opt => opt.value === surv?.obst?.malinas_travail)?.label ?? null,
        webDisplay: 'surveillance',
    },
    {
        '@type': 'surveillance',
        key: '05b42ddc-26ad-440a-9e1f-f61db1425e27',
        label: 'Durée des contractions',
        unit: 'sec',
        value: surv => surv?.obst?.duree_contractions ?? null,
        webDisplay: 'surveillance',
    },
    {
        '@type': 'surveillance',
        key: '05b42ddc-26ad-440a-9e1f-f61db1425e27',
        label: 'Intervales des contractions',
        unit: 'min',
        value: surv => surv?.obst?.intervalle_contraction ?? null,
        webDisplay: 'surveillance',
    },
    {
        '@type': 'surveillance',
        key: 'ca1a1a4c-84ab-4b03-980b-fccdf094218a',
        label: 'Intervales des contractions (min:sec)',
        value: surv => (surv?.obst?.contraction > 0 ? (0, utils_1.convertNumToMinSec)(surv?.obst?.contraction) : null),
        webDisplay: 'surveillance',
    },
    {
        '@type': 'surveillance',
        key: '12205c75-2c1f-473c-833d-9f549d8cd138',
        label: 'Perte des eaux',
        value: surv => data_1.MALINAS_PERTE_EAUX_OPTS.find(opt => opt.value === surv?.obst?.malinas_perte_eaux)?.label ?? null,
        webDisplay: 'surveillance',
    },
];
exports.survApgar = [
    {
        '@type': 'surveillance',
        key: 'eb9f4713-7c38-43d8-aa16-7be1d279ef0f',
        label: 'FC',
        value: surv => data_1.APGAR_FC_OPTS.find(opt => opt.value === surv?.apgar?.fc)?.label ?? null,
        webDisplay: 'surveillance',
    },
    {
        '@type': 'surveillance',
        key: 'a7c66ec7-31ab-43ce-a5b3-f6d85cbbc384',
        label: 'FR',
        value: surv => data_1.APGAR_FR_OPTS.find(opt => opt.value === surv?.apgar?.fr)?.label ?? null,
        webDisplay: 'surveillance',
    },
    {
        '@type': 'surveillance',
        key: '408db8bd-a9dc-4251-9a02-40cd7937c09c',
        label: 'Tonus',
        value: surv => data_1.APGAR_TONUS_OPTS.find(opt => opt.value === surv?.apgar?.tonus)?.label ?? null,
        webDisplay: 'surveillance',
    },
    {
        '@type': 'surveillance',
        key: 'd40d3048-21fa-4a7a-b0c1-87184620ff70',
        label: 'Réactivité',
        value: surv => data_1.APGAR_REACTIVITE_OPTS.find(opt => opt.value === surv?.apgar?.reactivite)?.label ?? null,
        webDisplay: 'surveillance',
    },
    {
        '@type': 'surveillance',
        key: '6033c022-224d-46b7-9238-8ffb142ca3bb',
        label: 'Coloration',
        value: surv => data_1.APGAR_COLORATION_OPTS.find(opt => opt.value === surv?.apgar?.coloration)?.label ?? null,
        webDisplay: 'surveillance',
    },
];
exports.survHead = [...exports.survTime, ...exports.survInconscience];
exports.survAb = [
    ...exports.survFr,
    ...exports.survO2aa,
    ...exports.survO2o2,
    ...exports.survDebitO2,
    ...exports.survDispositifOxygenotherapie,
    ...exports.survSpco,
    ...exports.survEtco,
    ...exports.survPeakFlow,
    ...exports.survRespirateurFr,
    ...exports.survRespirateurFio2,
    ...exports.survRespirateurVt,
    ...exports.survRespirateurPep,
];
exports.survC = [
    ...exports.survFc,
    ...exports.survPabd,
    ...exports.survPabg,
    ...exports.survPamd,
    ...exports.survPamg,
    ...exports.survPamByUser,
    ...exports.survTensionMoyenne,
    ...exports.survTensionManuelleSystolique,
    ...exports.survTensionManuelleSystoliqueGauche,
    ...exports.survTensionManuelleSystoliqueDroite,
    ...exports.survHemoglobine,
    ...exports.survChocIndex,
    ...exports.survHemocue,
    ...exports.survShockIndex,
    ...exports.survTrc,
    ...exports.survPaleurs,
    ...exports.survChocDate,
    ...exports.survChocTime,
    ...exports.survChocNbr,
    ...exports.survHemoglobineFloat,
];
exports.survD = [
    ...exports.survPupilles,
    ...exports.survScoreGla,
    ...exports.survGlaYeux,
    ...exports.survGlaVerbal,
    ...exports.survGlaMotricite,
    ...exports.survGlycemie,
    ...exports.survScoreSed,
];
exports.survE = [...exports.survTemp, ...exports.survTempZone, ...exports.survDouleur, ...exports.survHbco];
exports.survScore = [...exports.survApgarScore, ...exports.survMALINASScore, ...exports.survNIHSSScore];
